module.exports = __webpack_public_path__ + "img/71.37d35585.jpg";